<template>
  <div class="row newsLetterContainer">
    <div class="col-2 d-none d-md-block"><img src="/images/novice.png" alt="E-news" class="w-100 pt-3"></div>
    <div class="col-12 col-md-10">
      <div class="title d-none d-md-block">
          NEWSLETTER ABONNIEREN
      </div>
      <div class="row">
        <div class="col-3 d-block d-md-none">
          <img src="/images/novice.png" alt="E-news" class="w-100 pt-3">
        </div>
        <div class="col-9 col-md-12">
          <div class="title d-block d-md-none">
              NEWSLETTER ABONNIEREN
          </div>
          <template v-if="thankyou">
            <div class="text-center" v-html="feedbackMessage"></div>
          </template>
          <template v-else>
            Entdecken Sie Nähtricks und -tipps, lernen Sie die Stoffe kennen und bleiben Sie über alle Neuigkeiten und Aktionen auf dem Laufenden.
          </template>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <input type="text" :class="['form-control', {'is-invalid': errors.has('first_name')}]" v-model="form.first_name" :placeholder="$t('welcome.newsletter.form.first_name')">
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <input type="text" :class="['form-control', {'is-invalid': errors.has('last_name')}]" v-model="form.last_name" :placeholder="$t('welcome.newsletter.form.last_name')">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <input type="text" :class="['form-control', {'is-invalid': errors.has('email')}]" v-model="form.email" :placeholder="$t('welcome.newsletter.form.email')">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <button type="button" class="btn btn-green w-100" @click.prevent="submit" :disabled="loading">ANMELDEN</button>
          </div>
        </div>
      </div>
      <div class="form-group">
          <div class="checkbox">
              <label>
                  <input name="footer_nl_privacy" value="1" type="checkbox" v-model="form.confirm">
                  <span :class="[{'is-invalid': errors.has('confirm')}]">Ich stimme der <a href="/datenschutzbestimmungen">Datenschutzpolitik</a> zu.</span>
              </label>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Errors from '@Core/errors'
import XHR from '@Core/xhr'
import to from '@Utils/to'

export default {
  data () {
    return {
      thankyou: false,
      alreadySubscribed: false,
      loading: false,
      errors: new Errors(),
      form: new XHR({
        first_name: '',
        last_name: '',
        email: '',
        confirm: ''
      })
    }
  },

  methods: {
    async submit () {
      this.loading = true
      let [errors, response] = await to(this.form.post('/newsletter'))
      this.loading = false

      this.errors = errors || new Errors()
      if (!errors && response.success) {
        this.alreadySubscribed = !!response.already_subscribed
        this.showThankyou()
        this.form.reset()
      }
    },

    showThankyou () {
      this.thankyou = true
      setTimeout(() => { this.thankyou = false }, 4000)

      return true
    }
  },

  computed: {
    feedbackMessage () {
      return this.alreadySubscribed
        ? this.$t('general.newsletter.already_subscribed')
        : this.$t('general.newsletter.thankyou')
    }
  }

}
</script>
